import React, { useRef, useEffect, useState } from 'react';
import Video from '../video/Video'
import Image from '../Image/Image'
import PDF from '../PDF/PDF'
import Text from '../Text/Text'

const AssetContent = (props) => {
    const [value, setValue] = useState(props.default);
    const [values, setValues] = useState(props.values);
    const [original, setOriginal] = useState(props.default);
    const [updating, setUpdating] = useState(false);
    let unBlurFlag = false

    const inputRef = useRef();

    const assetType = (e) => {
        let assetType
        try {
            assetType = window.elvisContext.activeTab.assetSelection[0].assetDomain
        } catch (error) {
            return <h1>Nothing selected</h1>
        }

        if (assetType === "video") {
            return <Video  marklogicData={props.marklogicData} />
        }
        if (assetType === "image") {
            let previewUrl = window.elvisContext.activeTab.originalAssetSelection[0].previewUrl
            return <Image previewUrl={previewUrl}  />
        }
        if (assetType === "pdf") {
            return <PDF />
        }
        if (assetType === "text") {
            return <Text />
        }
    }


    return (
        assetType()
    );
};

export default AssetContent;